'use client';

import { Subsidiary } from '@coolblue-development/constants';
import { Flex, Link, ListItem, Typography } from '@coolblue-development/freddy';
import readExtendedExplanationTrigger from '@coolblue-development/ga4-events/triggers/InsuranceInformation/readExtendedExplanationTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { useTranslation } from '@i18n/useTranslation';

import { StyledUsefulLinksList } from './ExtendedWarrantyInformation.styled';

export default function MoreInformationBlock({
  customerServiceUrl,
  termsAndConditionsUrl
}: {
  customerServiceUrl: string;
  termsAndConditionsUrl: string;
}) {
  const { t } = useTranslation('webshop.productPage.extendedWarranty');
  const { trackEvent } = useAnalytics();
  const { subsidiary } = useRequestContext();

  function handleExtendedExplanationUrlsClick({
    index,
    url,
    redirect
  }: {
    index: number;
    url: string;
    redirect: string;
  }) {
    trackEvent(
      readExtendedExplanationTrigger({
        sub_feature: 'product_page',
        index: index,
        url: url,
        redirect: redirect,
        total_indices: 2
      })
    );
  }

  return (
    <Flex direction='column' gap={200}>
      <Typography component='h3' variant='h5' mb={0}>
        {t('moreInfo.title')}
      </Typography>
      <StyledUsefulLinksList>
        {subsidiary !== Subsidiary.BE && (
          <ListItem>
            <Link
              href={customerServiceUrl}
              onClick={() =>
                handleExtendedExplanationUrlsClick({
                  url: customerServiceUrl,
                  index: 1,
                  redirect: t('moreInfo.links.general')
                })
              }
            >
              {t('moreInfo.links.general')}
            </Link>
          </ListItem>
        )}

        <ListItem>
          <Link
            href={termsAndConditionsUrl}
            onClick={() =>
              handleExtendedExplanationUrlsClick({
                url: termsAndConditionsUrl,
                index: 2,
                redirect: t('moreInfo.links.termsAndConditions')
              })
            }
          >
            {t('moreInfo.links.termsAndConditions')}
          </Link>
        </ListItem>
      </StyledUsefulLinksList>
    </Flex>
  );
}
